import { ORIENTATION } from 'components/ToolkitV2/CardV2/Card.typed';
import convertToFriendlyPath from 'utils/FriendlyPath';

import * as Styled from 'components/PageWrappers/AdDetails/components/PostEnquirySimilarAdsModal/components/SimilarAdCard/SimilarAdCard.styled';

import { Price } from 'components/ToolkitV2/CardV2/components//Price/Price';
import { Image } from 'components/ToolkitV2/CardV2/components/Image/Image';

import type { SimilarAdCardProps } from 'components/PageWrappers/AdDetails/components/PostEnquirySimilarAdsModal/components/SimilarAdCard/SimilarAdCard.typed';

function SimilarAdCard(props: SimilarAdCardProps) {
  const {
    domain,
    friendlyUrl,
    updateCampaignNumber,
    header,
    currency,
    price,
    oldPriceView,
    financeSummary,
    priceOnRequest,
    photos,
    imageAlt,
    hide,
  } = props;

  const friendlyPath = convertToFriendlyPath(
    domain,
    friendlyUrl,
    updateCampaignNumber,
  );

  return (
    <Styled.SimilarAdLink href={friendlyPath} hide={hide}>
      <Styled.SimilarAdCard
        orientationSmall={ORIENTATION.VERTICAL}
        paddingSmall="S4"
        paddingMedium="S8"
        gapSmall={oldPriceView.showOldPrice ? 'M16' : 'S8'}
        header={<Styled.Header>{header}</Styled.Header>}
        image={
          <Image
            heightVertical={108}
            widthVertical={144}
            alt={imageAlt}
            orientationSmall={ORIENTATION.VERTICAL}
            src={photos && photos[0].small2 ? photos[0].small2 : undefined}
            imgSrcWebp={
              photos && photos[0].small2Webp ? photos[0].small2Webp : undefined
            }
          />
        }
        footer={
          <Price
            currency={currency}
            price={price}
            oldPrice={oldPriceView.showOldPrice ? oldPriceView.oldPrice : ''}
            pricePerMonth={financeSummary?.price}
            priceOnRequest={priceOnRequest}
            isGrid
            displayLabels={false}
          />
        }
      />
    </Styled.SimilarAdLink>
  );
}

export { SimilarAdCard };
